import axios from 'axios'
import {Message} from 'element-ui'

let baseURL: any = '';
const origin = location.hostname; //当前访问域名
if (process.env.NODE_ENV === "development") {
    baseURL = process.env.VUE_APP_BASE_PDF_API_PROXY;
} else {
    if (origin.indexOf("-testserver") > -1) {
        baseURL = process.env.VUE_APP_DEV_PDF_API;
    } else {
        baseURL = process.env.VUE_APP_MASTER_PDF_API;
    }
}
// baseURL = 'https://gec-api-testserver.gecacademy.cn/api'
const config = {
    baseURL,
    timeout: 50 * 1000,
    withCredentials: true // 开启自动获取cookie
}

const _axios = axios.create(config)
_axios.interceptors.request.use(
    cfg => {
        return cfg
    },
    err => {
        return Promise.reject(err)
    }
)
_axios.interceptors.response.use(
    cfg => {
        const {error} = cfg.data
        if (error.returnCode !== 0) {
            Message.error(error.returnUserMessage)
            return Promise.reject(new Error(error.returnUserMessage))
        }
        return cfg.data.data
    },
    err => {
        Message.error(err.message)
        return Promise.reject(err)
    }
)

export default _axios
